// extracted by mini-css-extract-plugin
export var active = "_dx-7";
export var container = "_dx-0";
export var evenWidth = "_dx-4";
export var large = "_dx-5";
export var outlet = "_dx-8";
export var slide = "_dx-2";
export var small = "_dx-6";
export var tab = "_dx-3";
export var tabs = "_dx-1";